import styled, { css } from 'styled-components';
import Icon from "../../basic/Icon/Icon.js";
import BodyText from "../../type/BodyText.js";
import { getFieldPadding, getSizeStyles } from "./helpers.js";
/* Icon and text */
export var InputIcon = styled(Icon).withConfig({
  componentId: "CL__sc-t3cgmz-0"
})(["pointer-events:none;"]);
export var StyledPlaceholder = styled.span.withConfig({
  componentId: "CL__sc-t3cgmz-1"
})(["color:var(--gray-5);font:inherit;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1 0;"]);
export var StyledInputIconContainer = styled.div.withConfig({
  componentId: "CL__sc-t3cgmz-2"
})(["display:flex;align-items:center;justify-content:center;height:100%;width:calc( 100% - calc(", ") * 2 );position:absolute;top:0;gap:var(--spacing-1);pointer-events:none;", " font:", ";&.drag-and-drop,&.uploading{display:none;left:50%;transform:translateX(-50%);width:auto;", "{font-weight:bold;}}&.drag-and-drop ", "{color:var(--highlight-color);}&.uploading{", "{animation:rotate 2s linear infinite;@keyframes rotate{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}}", "{color:var(--text-color-dim);}}"], _ref => {
  var {
    fieldSize
  } = _ref;
  return getFieldPadding(fieldSize).left;
}, _ref2 => {
  var {
    fieldSize
  } = _ref2;
  return "left: ".concat(getFieldPadding(fieldSize).left, ";");
}, _ref3 => {
  var {
    fieldSize
  } = _ref3;
  return fieldSize === 'large' ? 'var(--body-text-medium)' : fieldSize === 'small' ? 'var(--body-text-x-small)' : 'var(--body-text-small)';
}, StyledPlaceholder, StyledPlaceholder, InputIcon, StyledPlaceholder);
export var StyledFileContainer = styled.div.withConfig({
  componentId: "CL__sc-t3cgmz-3"
})(["display:flex;align-items:center;justify-content:flex-start;padding:", ";padding-right:", ";gap:var(--spacing-1);"], _ref4 => {
  var {
    fieldSize
  } = _ref4;
  return "".concat(getFieldPadding(fieldSize).imagePadding);
}, _ref5 => {
  var {
    fieldSize
  } = _ref5;
  return "".concat(getFieldPadding(fieldSize).right);
});
export var StyledFilePreview = styled.div.withConfig({
  componentId: "CL__sc-t3cgmz-4"
})(["display:flex;gap:var(--spacing-1);align-items:center;max-width:100%;flex:1 0;"]);
export var Thumbnail = styled.div.withConfig({
  componentId: "CL__sc-t3cgmz-5"
})(["border-radius:var(--border-radius-x-small);border:1px solid var(--gray-5);position:absolute;left:0;top:0;"]);
export var StyledThumbnails = styled.div.withConfig({
  componentId: "CL__sc-t3cgmz-6"
})(["position:relative;height:", ";width:", ";flex:0 0 ", ";", "{width:calc( ", " * ", " );height:calc( ", " * ", " );background:var(--gray-5) center / contain no-repeat;&:nth-child(2){top:10%;left:10%;}&:last-child:not(:only-child){top:20%;left:20%;}}"], _ref6 => {
  var {
    fieldSize
  } = _ref6;
  return getFieldPadding(fieldSize).previewImage;
}, _ref7 => {
  var {
    fieldSize
  } = _ref7;
  return getFieldPadding(fieldSize).previewImage;
}, _ref8 => {
  var {
    fieldSize
  } = _ref8;
  return getFieldPadding(fieldSize).previewImage;
}, Thumbnail, _ref9 => {
  var {
    count
  } = _ref9;
  return count > 1 ? '.8' : '1';
}, _ref0 => {
  var {
    fieldSize
  } = _ref0;
  return getFieldPadding(fieldSize).previewImage;
}, _ref1 => {
  var {
    count
  } = _ref1;
  return count > 1 ? '.8' : '1';
}, _ref10 => {
  var {
    fieldSize
  } = _ref10;
  return getFieldPadding(fieldSize).previewImage;
});
export var StyledBadges = styled.div.withConfig({
  componentId: "CL__sc-t3cgmz-7"
})(["display:flex;gap:var(--spacing-1);flex-wrap:wrap;flex:1 0;padding-right:48px;"]);

/* Menu Buttons */
export var FileInfoTooltip = styled.a.withConfig({
  componentId: "CL__sc-t3cgmz-8"
})(["display:block;height:24px;width:18px;padding:3px 0;transition:color var(--hover-transition);cursor:pointer;> span{display:block;color:var(--text-color-dim);}&:hover span{color:var(--highlight-color);}"]);
export var StyledTooltipContent = styled.div.withConfig({
  componentId: "CL__sc-t3cgmz-9"
})(["display:flex;flex-direction:column;gap:3px;width:324px;padding:var(--spacing-1) var(--spacing-1) var(--spacing-2);color:var(--text-color-inverse-dim);header{display:flex;gap:var(--spacing-2);padding-bottom:var(--spacing-1);align-items:flex-start;justify-content:space-between;}"]);
export var StyledTooltipContentBlock = styled.div.withConfig({
  componentId: "CL__sc-t3cgmz-10"
})(["display:flex;align-items:flex-start;gap:var(--spacing-1);max-width:312px;> div{display:flex;flex-direction:column;max-width:calc(100% - 24px);p{word-wrap:break-word;}}"]);
export var StyledTooltipMessage = styled(BodyText).withConfig({
  componentId: "CL__sc-t3cgmz-11"
})(["color:inherit;padding-top:var(--spacing-1);"]);
export var StyledMenuButtons = styled.div.withConfig({
  componentId: "CL__sc-t3cgmz-12"
})(["display:flex;gap:var(--spacing-1);align-items:center;justify-content:center;height:100%;position:absolute;top:50%;transform:translateY(-50%);padding-right:", ";right:0;z-index:2;div:last-child{display:inline-flex;}"], _ref11 => {
  var {
    fieldSize
  } = _ref11;
  return getFieldPadding(fieldSize).right;
});

/* FileUpload */

export var StyledFileUpload = styled.input.withConfig({
  componentId: "CL__sc-t3cgmz-13"
})(["appearance:none;display:block;color:transparent;position:relative;box-shadow:none;outline:none;width:100%;cursor:", ";padding:", ";&::-moz-focus-inner{margin-top:-2px;margin-bottom:-2px;border:0;padding:0;}::file-selector-button{cursor:", ";opacity:0;}"], _ref12 => {
  var {
    disabled
  } = _ref12;
  return disabled ? 'default' : 'pointer';
}, _ref13 => {
  var {
    fieldSize
  } = _ref13;
  return fieldSize && getFieldPadding(fieldSize).all;
}, _ref14 => {
  var {
    disabled
  } = _ref14;
  return disabled ? 'default' : 'pointer';
});
export var StyledInputSizifier = styled.div.withConfig({
  componentId: "CL__sc-t3cgmz-14"
})(["--file-upload-bkg:var(--blue-1);[data-theme='dark'] &{--file-upload-bkg:var(--blue-8);}position:relative;width:", ";", ",", "{", " border-radius:var(--border-radius-x-small);transition:border-color var(--hover-transition);", ";", " &:not(:disabled):hover{box-shadow:none;border-color:var(--highlight-color);}&:not(:disabled):focus-visible{box-shadow:0 0 5px var(--highlight-color);border-color:var(--highlight-color);}&::selection{background:var(--highlight-color);color:var(--main-bkg-color);}&:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:focus-visible{box-shadow:0 0 0 1000px var(--main-bkg-color) inset;}", " ", "}", " ", "{border-style:dashed;", " ", "}", ";"], _ref15 => {
  var {
    fieldWidth
  } = _ref15;
  return fieldWidth === 'full' ? '100%' : "".concat(fieldWidth, "px");
}, StyledFileUpload, StyledFileContainer, _ref16 => {
  var {
    intensity
  } = _ref16;
  return intensity === 'light' ? css(["background:var(--surface-bkg-color);border:1px solid var(--border-color-dim);"]) : css(["background:var(--main-bkg-color);border:1px solid var(--border-color);"]);
}, _ref17 => {
  var {
    fieldSize
  } = _ref17;
  return getSizeStyles(fieldSize);
}, _ref18 => {
  var {
    fieldHeight
  } = _ref18;
  return fieldHeight && css(["height:", "px;"], fieldHeight);
}, _ref19 => {
  var {
    error,
    errorMessage
  } = _ref19;
  return (error || errorMessage) && css(["border-color:var(--error-color);&:not(:disabled):hover{border-color:var(--error-color);}&:not(:disabled):focus-visible{box-shadow:0 0 5px var(--error-color);border-color:var(--error-color);}"]);
}, _ref20 => {
  var {
    disabled
  } = _ref20;
  return disabled && css(["background-color:var(--surface-bkg-color);border-color:var(--border-color-dim);"]);
}, _ref21 => {
  var {
    fieldHeight
  } = _ref21;
  return fieldHeight && css(["height:", "px;", "{flex:unset;}"], fieldHeight, StyledPlaceholder);
}, StyledFileUpload, _ref22 => {
  var {
    isDragOver,
    isUploading
  } = _ref22;
  return isDragOver && !isUploading && css(["border-color:var(--highlight-color);border-style:dashed;background:var(--file-upload-bkg);& ~ ", "{&.default,&.uploading{display:none;}&.drag-and-drop{display:flex;}}"], StyledInputIconContainer);
}, _ref23 => {
  var {
    isUploading
  } = _ref23;
  return isUploading && css(["border-style:solid;& ~ ", "{&.default,&.drag-and-drop{display:none;}&.uploading{display:flex;}}"], StyledInputIconContainer);
}, _ref24 => {
  var {
    filled
  } = _ref24;
  return filled ? css(["", ",", "{display:none;}"], StyledFileUpload, StyledInputIconContainer) : css(["", "{display:none;}"], StyledFileContainer);
});